<template>
    <div class="w-full flex mb-4 border rounded-lg border-info h-28">
        <div
            class="flex justify-center items-center bg-brand-blue rounded-lg h-full w-2/12 lg:w-1/12 text-white"
        >
            <strong>
                {{
                    `${file.url.split("").reverse().join("").split(".")[0]}`
                        .split("")
                        .reverse()
                        .join("")
                }}
            </strong>
        </div>
        <div class="px-2 py-2 relative w-10/12 lg:w-11/12">
            <router-link
                :to="`/app/files/detail/${file.id}`"
                class="text-theme-primary"
            >
                <p>{{ file.alt || "Indefinido" }}</p>
            </router-link>
            <a :href="file.url" target="_blank" rel="noopener">
                <small> URL </small>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: "FileItem",
    props: {
        file: {
            type: Object,
            default: () => ({}),
            required: true
        }
    }
};
</script>
